addendumLetter.classy.controller({
    name: 'AddendumLetterController',
    inject: ['$scope', '$rootScope', 'authServiceFactory', 'standardCudArrayFactory', 'ModelService', 'SchoolAddendumModelService', 'HelpSystemModelService'],
    init: function()
    {
       //this.$.items = this.ModelService.school.addendum.get();
       this.$.SchoolAddendumModelService = this.SchoolAddendumModelService;
       this.$rootScope.model = this.SchoolAddendumModelService;
       this.$.arrayCud = new this.standardCudArrayFactory(this.SchoolAddendumModelService,
           this.authServiceFactory.getAuth().schoolID, this.SchoolAddendumModelService.get(), this, ['items']);
       this.$.authServiceFactory = this.authServiceFactory; 
       this.$.HelpSystemModelService = this.HelpSystemModelService;
       this.$.html = '<p>The Addendum Letter gives Administrators the opportunity to provide  additional instructions to families pertaining to the FAST Financial Aid  application process. Prior to this letter&#39;s availability, it must be  sent to FAST for approval, simply to ensure that the instructions do not  interfere with normal ISM/FAST procedures. Once approved, the Addendum  Letter is an e-mail that is automatically sent to the parent once they  pay for the application online. The Addendum Letter is e-mailed along  with the Documents to Collect e-mail, which specifies which tax  documents are required for income verification, and the Confirmation of  Submission e-mail, which confirms that the credit card payment completed.</p>';
       this.$.authServiceFactory.getAuth();
    },
    activeChange: function(field, index)
    {
        //console.log(this.$.items[index][field]);
    },
    add: function()
    {
      this.$.arrayCud.editItem[this.$.items.length] = true;
      this.$.items.push(this.$.arrayCud.model.new());
      //this.editItem[this.$.items.length] = true;
      //this.$.items.push(this.model.new());
    },
    submit: function(scope, instance, form) 
    {
      this.$.arrayCud.startSaveProcess(scope, instance, form);
    }
});

